import * as React from 'react';

import PropTypes from 'prop-types';

import ToastActions from 'actions/ToastActions';
// @ts-ignore
import View from 'components/View';
import LinkDevicePage from 'user/components/LinkDevicePage';
// @ts-ignore
import UserActions from 'user/UserActions';

class SetupEmail extends React.Component<{}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  handleSave = (_?: string, deviceUid?: string) => {
    UserActions.update({ email: deviceUid }).then(
      () => this.context.router.push('/'),
      (error: Error) => {
        console.debug(error);
        console.error('SetupEmail: could not save user email');
        ToastActions.showErrorToast('An error occured, please try again.');
      }
    );
  };

  render() {
    return (
      <View>
        <LinkDevicePage
          onDone={this.handleSave}
          deviceType="email"
          title="What is your email address?"
          subtext={
            'We’ll send a code to your device. This will be your primary email address for Remind.'
          }
        />
      </View>
    );
  }
}

export default SetupEmail;
